import type { Vehicle } from '@/types/Vehicle';

interface VehicleCardProps {
  vehicle: Vehicle;
  onEdit: () => void;
  onDelete: () => void;
  deleting?: boolean;
}

export default function VehicleCard({ vehicle, onEdit, onDelete, deleting }: VehicleCardProps) {
  return (
    <div className="vehicle-card card-elev">
      <div className="part-cat" style={{ wordBreak: 'break-all' }}>
        {vehicle.vin ? `VIN ${vehicle.vin}` : 'No VIN saved'}
      </div>
      <div className="part-title" style={{ fontSize: 18, marginBottom: 8 }}>
        {vehicle.year} {vehicle.make} {vehicle.model}
      </div>
      {vehicle.engine && (
        <div style={{ fontSize: 13, color: 'var(--text)', marginBottom: 4 }}>{vehicle.engine}</div>
      )}
      {vehicle.project && (
        <div style={{ fontSize: 12.5, color: 'var(--text-dim)', marginBottom: 12 }}>{vehicle.project}</div>
      )}
      {vehicle.notes && (
        <div style={{ fontSize: 12.5, color: 'var(--text-dim)', marginBottom: 12, fontStyle: 'italic', borderLeft: '2px solid var(--line-2)', paddingLeft: 10 }}>
          {vehicle.notes}
        </div>
      )}
      <div
        style={{
          display: 'flex',
          gap: 18,
          paddingTop: 14,
          borderTop: '1px dashed var(--line-2)',
          fontFamily: 'var(--mono)',
          fontSize: 11,
        }}
      >
        <div>
          <span style={{ color: 'var(--gold)' }}>{vehicle.wishlist.length}</span> on wishlist
        </div>
        <div style={{ flex: 1 }} />
        <button type="button" className="btn sm dark" onClick={onEdit}>Edit</button>
        <button type="button" className="btn sm danger" onClick={onDelete} disabled={deleting}>
          {deleting ? '…' : 'Delete'}
        </button>
      </div>
    </div>
  );
}
